import { render, staticRenderFns } from "./StockRequests.vue?vue&type=template&id=1d0bf06a"
import script from "./StockRequests.vue?vue&type=script&lang=js"
export * from "./StockRequests.vue?vue&type=script&lang=js"
import style0 from "./StockRequests.vue?vue&type=style&index=0&id=1d0bf06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports